import { AutogenModelEdiMultistop, AutogenRowEdiMultistop } from "./autogen/AutogenModelEdiMultistop";

export class ModelEdiMultistop extends AutogenModelEdiMultistop<RowEdiMultistop> {
    constructor() {
        super(RowEdiMultistop);
    }
}

export class RowEdiMultistop extends AutogenRowEdiMultistop {
}